document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const mobileNav = document.getElementById('barrose-mobile-nav');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      mobileNav.hidden = !open;
    });
  }

  const galleryMain = document.getElementById('main-product-image');
  document.querySelectorAll('.thumb[data-src]').forEach(button => {
    button.addEventListener('click', () => {
      if (!galleryMain) return;
      galleryMain.src = button.dataset.src;
      galleryMain.alt = button.dataset.alt || '';
      document.querySelectorAll('.thumb[data-src]').forEach(item => {
        item.classList.toggle('active', item === button);
        item.setAttribute('aria-pressed', String(item === button));
      });
    });
  });

  const search = document.getElementById('help-search');
  if (search) {
    const questions = [...document.querySelectorAll('.faq-item')];
    const status = document.getElementById('help-search-status');
    search.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      for (const question of questions) {
        question.hidden = query !== '' && !question.textContent.toLowerCase().includes(query);
        if (!question.hidden) visible++;
      }
      if (status) status.textContent = query ? `${visible} matching questions` : '';
    });
  }
});
